export const PACKAGE_NAME = 'jiraIssueFieldStatistics';
export const ERROR_ID = 'copyToClipboard';
export const TEAM_NAME = 'helios-reports';
